$(function() {
 	"use strict";
 	$(document).ready(function(){
        container_spacer();
        $(window).resize(function(){
            container_spacer();
        });
      
        $(".js-content-products-slider .content-products__title").click(function(){
            $(".template-article .blog-detail-product").toggleClass("loaded");
            $("body").toggleClass("js-content-products-open");
        });
      
        if ($(".best-sellers-section").length > 0){
            $('.best-sellers-section .grid-flex').owlCarousel({
                loop:true,
                nav: true,
                dots: false,
                center: true,
                items: 4,
                margin: 30,
                autoplay:true,
                autoplayTimeout:5000,
                autoplaySpeed: 1000,
                responsive: {
                    0: {
                        items: 1,
                    },
                    768: {
                        items: 1,
                        nav: true,
                		dots: false,
                    },
                    939: {
                        items: 2,
                    },
                    1025: {
                        items: 4,
                        margin: 30,
                    },
                    1921: {
                        items: 4,
                        margin: 60,
                    },
                }
            });
        }

        if ($(".article__comments_lising ul").length > 0){
            $('.article__comments_lising ul').owlCarousel({
                loop:true,
                nav: true,
                dots: false,
                center: true,
                margin: 30,
                items: 1,
                // autoplay:true,
                autoplayTimeout:5000,
                autoplaySpeed: 1000,
            });
        }

      

      $('.faq-accordion > .faq-panel > .faq-content ').hide();
      $('.faq-accordion > .faq-panel:first-child > .faq-content ').show();
      $('.faq-accordion > .faq-panel .heading').click(function() {
          $(this).parent().toggleClass("active");
          $(this).next().slideToggle();
          $(".faq-accordion > .faq-panel .faq-content").not($(this).next()).slideUp(300);         
          $(this).parent().siblings().removeClass("active");
      });

      if ($('.collection-faq-content:empty').length) {
          $('.collectopn-faq').addClass("hide");
      };
      
        $(".menu-toggle-custom .burger-icon").click(function(){
          $(".menu-toggle-custom").addClass("open");
        });
        $(".menu-toggle-custom .close-mobile-menu").click(function(){
          $(".menu-toggle-custom").removeClass("open");
        });

        $(".review-slider-custom  .jdgm-carousel__item-wrapper").addClass("owl-carousel");
        
        if ($(".review-slider-custom  .jdgm-carousel__item-wrapper").length > 0){
            $('.review-slider-custom  .jdgm-carousel__item-wrapper').owlCarousel({
                loop:true,
                nav: true,
                dots: false,
                center: true,
                items: 4,
                margin: 30,
                // autoplay:true,
                // autoplayTimeout:5000,
                // autoplaySpeed: 1000,
                responsive: {
                    0: {
                        items: 1,
                    },
                    768: {
                        items: 1,
                        nav: true,
                		dots: false,
                      center: false,
                    },
                    1025: {
                        items: 2,
                        nav: true,
                		dots: false,
                      center: false,
                    },
                    1440: {
                        items: 2,
                        margin: 30,
                        center: false,
                    },
                    1801: {
                        items: 4,
                        margin: 30,
                        center: true,
                    },
                    1921: {
                        items: 4,
                        margin: 50,
                        center: true,
                    },
                }
            });
        }
      // $(".product-detail__price-custom").appendTo(".variant-custom-option button.cc-select__btn.Size");
      
      // $(".btn--quicklook").click(function(){
      //   setTimeout(function () {
      //     $(".quickbuy .quickbuy-form .product-dropdown-custom .quickbuy__price.product-price").appendTo(".quickbuy .quickbuy-form .product-dropdown-custom .cc-select__btn.Size");
      //   }, 100);
      // });
  
      review_slider_page();
      // product_image_slider_page();
      $(window).resize(function(){
            review_slider_page();
            // product_image_slider_page();
      });

      $(function(){
        $('#BlogTagFilter').on('change', function () {
        var url = $(this).val(); // get selected value
        if (url) { // require a URL
        window.location = url; // redirect
        }
        return false;
        });
      });
      // cusrom select dropdown start
          $(".custom-select").each(function() {
            var classes = $(this).attr("class"),
                id      = $(this).attr("id"),
                name    = $(this).attr("name");
            var template =  '<div class="' + classes + '">';
                template += '<span class="custom-select-trigger">' + $(this).attr("placeholder") + '</span>';
                template += '<div class="custom-options">';
                $(this).find("option").each(function() {
                  template += '<a class="custom-option ' + $(this).attr("class") + '" href="' + $(this).attr("value") + '">' + $(this).html() + '</a>';
                });
            template += '</div></div>';
            
            $(this).wrap('<div class="custom-select-wrapper"></div>');
            $(this).hide();
            $(this).after(template);
          });
          $(".custom-option:first-of-type").hover(function() {
            $(this).parents(".custom-options").addClass("option-hover");
          }, function() {
            $(this).parents(".custom-options").removeClass("option-hover");
          });
          $(".custom-select-trigger").on("click", function() {
            $('html').one('click',function() {
              $(".custom-select").removeClass("opened");
            });
            $(this).parents(".custom-select").toggleClass("opened");
            event.stopPropagation();
          });
          $(".custom-option").on("click", function() {
            $(this).parents(".custom-select-wrapper").find("select").val($(this).data("value"));
            $(this).parents(".custom-options").find(".custom-option").removeClass("selection");
            $(this).addClass("selection");
            $(this).parents(".custom-select").removeClass("opened");
            $(this).parents(".custom-select").find(".custom-select-trigger").text($(this).text());
          });
      // cusrom select dropdown end 
        $('.product-info-sticky .price ul li:first-child').addClass( "show" );
        $('.product-dropdown-custom select').change(function(){ 
            var value = $(this).val();
            var value2 = ('price' +value);
            console.log(value2);
            $('.product-info-sticky .price ul li').removeClass( "show" );
            $('.product-info-sticky .price ul li.'+value2).addClass( "show" );
        });

      
    });
  
    function container_spacer(){
        var win = jQuery(window).width();
        var con = jQuery('.page-width').width();
        var total = (win - con) / 2;

        jQuery('.image-with-text-right .image-with-text__content, .padding-right').css('padding-right', total);
        jQuery('.image-with-text--reverse .image-with-text__content, .padding-left').css('padding-left', total);
    } 
    
    function review_slider_page(){
      var checkWidth = $(window).width();
      var slider_page_review = $(".template-product .product-page-riview-custom .jdgm-rev-widg__reviews");
      if (checkWidth > 1800) {
        if (typeof slider_page_review.data('owl.carousel') != 'undefined') {
          slider_page_review.data('owl.carousel').destroy();
        }
        slider_page_review.removeClass('owl-carousel');
      }else if (checkWidth < 1800) {
           slider_page_review.addClass("owl-carousel");
        if (slider_page_review.length > 0){
            slider_page_review.owlCarousel({
                loop:true,
                nav: true,
                dots: false,
                center: true,
                items: 4,
                margin: 30,
                // autoplay:true,
                // autoplayTimeout:5000,
                // autoplaySpeed: 1000,
                responsive: {
                    0: {
                        items: 1,
                    },
                    768: {
                        items: 1,
                        nav: true,
                      dots: false,
                      center: false,
                    },
                    1025: {
                        items: 2,
                        nav: true,
                      dots: false,
                      center: false,
                    },
                    1440: {
                        items: 2,
                        margin: 30,
                        center: false,
                    },
                    1801: {
                        items: 4,
                        margin: 30,
                        center: true,
                    },
                    1921: {
                        items: 4,
                        margin: 50,
                        center: true,
                    },
                }
            });
        }
      }
    }

    function product_image_slider_page(){
      var checkWidthproduct = $(window).width();
      var slider_page_reviewproduct = $(".template-product .product-detail .product-detail__images");
      if (checkWidthproduct > 1024) {
        if (typeof slider_page_reviewproduct.data('owl.carousel') != 'undefined') {
          slider_page_reviewproduct.data('owl.carousel').destroy();
        }
        slider_page_reviewproduct.removeClass('owl-carousel');
      }else if (checkWidthproduct < 1800) {
           slider_page_reviewproduct.addClass("owl-carousel");
        if (slider_page_reviewproduct.length > 0){
            slider_page_reviewproduct.owlCarousel({
                loop:true,
                nav: true,
                dots: false,
                center: true,
                items: 1,
                // autoplay:true,
                // autoplayTimeout:5000,
                // autoplaySpeed: 1000,
            });
        }
      }
    }

    $(window).on("load scroll", function() {
      $('.product-recommendations-container').addClass("owl-carousel");
      if ($(".product-recommendations-container").length > 0){
            $('.product-recommendations-container').owlCarousel({
                loop:true,
                nav: true,
                dots: false,
                center: true,
                items: 4,
                margin: 30,
                // autoplay:true,
                autoplayTimeout:5000,
                autoplaySpeed: 1000,
                responsive: {
                    0: {
                        items: 1,
                    },
                    768: {
                        items: 1,
                        nav: true,
                		dots: false,
                    },
                    939: {
                        items: 2,
                    },
                    1025: {
                        items: 4,
                        margin: 30,
                    },
                    1921: {
                        items: 4,
                        margin: 60,
                    },
                }
            });
        }
    });
    
    jQuery(window).on("load",function(){
      jQuery(".template--16967315816746__main-select-fresh-grinding-label").trigger("click");
      jQuery(".custom-but-option li").click(function(){
        var comboid = $(this).data("comboid");
        var labelid = $(this).data("labelid");
        jQuery("."+labelid).trigger("click");
        console.log(comboid);
        jQuery("#"+comboid).trigger("click");
      });
    });




      $.fn.visible = function(partial) {
        
          var $t            = $(this),
              $w            = $(window),
              viewTop       = $w.scrollTop(),
              viewBottom    = viewTop + $w.height(),
              _top          = $t.offset().top,
              _bottom       = _top + $t.height(),
              compareTop    = partial === true ? _bottom : _top,
              compareBottom = partial === true ? _top : _bottom;
        
        return ((compareBottom <= viewBottom) && (compareTop >= viewTop));
    
      };
    
    $(window).scroll(function(event) {
      
      $(".section-product-template").each(function(i, el) {
        var el = $(el);
        if (el.visible(true)) {
          el.removeClass("sticky-cart-add"); 
        } else {
          el.addClass("sticky-cart-add");
        }
      });
      
    });

    jQuery(document).ready(function() {

            $(function () {

                // Define window variables

                var winScrollTop = $(window).scrollTop();
                var winHeight = window.innerHeight;
                var winWidth = window.innerWidth;

                // Define scene classes.
                var sceneClass = 'scene';
                var sceneActiveClass = 'scene--active';
                var sceneEndedClass = 'scene--ended';

                $(window).on('resize', function () {
                    winHeight = window.innerHeight;
                    winWidth = window.innerWidth;
                });

                // Scene classes function.
                function setScene($el) {

                    // Get bounding values from section.
                    var bounding = $el.data('elDom').getBoundingClientRect();

                    if (bounding.top > winHeight) {

                        // Section is below the viewport.
                        // Section has not ended or started, therefore remove classes.
                        $el.find('.scene').removeClass('scene--active');
                        $el.find('.scene').removeClass('scene--ended');
                        $('body').removeClass('scene--end');
                        $('body').removeClass('scene--actived');

                    } else if (bounding.bottom < 0) {

                        // Section is above the viewport.
                        // Section has ended, therefore remove classes.
                        $el.find('.scene').addClass('scene--ended');
                        $el.find('.scene').removeClass('scene--active');
                        $('body').addClass('scene--end');
                        // $('body').removeClass('scene--actived');

                    } else {

                        // We're now inside the section, not below or above.
                        // If top of section is at top of viewport, add class active.
                        if (bounding.top <= 0) {
                            $el.find('.scene').addClass('scene--active');
                            $('body').addClass('scene--actived');
                        }

                        // If top of section is below top of viewport, remove class active.
                        if (bounding.top > 0) {
                            $el.find('.scene').removeClass('scene--active');
                            $('body').removeClass('scene--actived');
                        }

                        // If bottom of section is at bottom of viewport, add class ended.
                        if (bounding.bottom <= (winHeight)) {
                            $el.find('.scene').addClass('scene--ended');
                            $('body').addClass('scene--end');
                        }

                        // If bottom of section is not at bottom of viewport, remove class ended.
                        if (bounding.bottom > (winHeight)) {
                            $el.find('.scene').removeClass('scene--ended');
                            $('body').removeClass('scene--end');
                        }
                    }
                }

                // This function sets up the horizontal scroll. This applies data attributes to the section for later use.
                function setUpHorizontalScroll($el) {

                    var sectionClass = ('horizontal-scroll-section');

                    // Set content wrapper variables & data attributes.
                    var $contentWrapper = $el.find('.scene-inner');
                    var contentWrapperDom = $contentWrapper.get(0);
                    $el.data('contentWrapper', $contentWrapper);
                    $el.data('contentWrapperDom', contentWrapperDom);

                    // Set content wrapper scroll width variables & data attributes.
                    var contentWrapperScrollWidth = $el.data('contentWrapperDom').scrollWidth;
                    $el.data('contentWrapperScrollWidth', contentWrapperScrollWidth);

                    // Set right max variables & data attributes.
                    var rightMax = $el.data('contentWrapperScrollWidth') - winWidth;
                    var rightMaxMinus = -(rightMax);
                    $el.data('rightMax', Number(rightMaxMinus));

                    // Set initialized data variable to false do incidate scrolling functionality doesn't work yet.
                    $el.data('initalized', false);

                    

                    // Set data attribute for outerHeight.
                    $el.data('outerHeight', $el.outerHeight());

                    // Set data attribute for offset top.
                    $el.data('offsetTop', $el.offset().top);

                    // Set data initialized data variable to true to indicate ready for functionality.
                    $el.data('initalized', true);

                    

                    // Add class of init
                    $el.addClass('horizontal-scroll-section--init');
                }

                function resetHorizontalScroll($el) {
                  
                  
                    // Update data attribute for content wrapper scroll width.
                
                  var contentWrapperScrollWidth = $el.data('contentWrapperDom').scrollWidth;
                    $el.data('contentWrapperScrollWidth', contentWrapperScrollWidth);
                  

                    // Update rightMax variables & data attributes.
                    // rightMax = $el.data('contentWrapperScrollWidth') - winWidth;
                    // rightMaxMinus = -(rightMax);
                    // $el.data('rightMax', Number(rightMaxMinus));

                    // Update height of section to the scroll width of content wrapper.
                    $el.css('height', $el.data('contentWrapperScrollWidth'));

                    // Update data attribute for outerHeight.
                    $el.data('outerHeight', $el.outerHeight());

                    // Update data attribute for offset top.
                    $el.data('offsetTop', $el.offset().top);

                    
                }

                var $horizontalScrollSections = $('.horizontal-scroll-section');
                var $horizontalScrollSectionsTriggers = $horizontalScrollSections.find('.trigger');

                // Each function - set variables ready for scrolling functionality. Call horizontal scroll functions on load and resize.
                $horizontalScrollSections.each(function (i, el) {
                  
                    var $thisSection = $(this);

                    $(this).data('elDom', $(this).get(0));

                    // Set up horizontal scrolling data attributes and show section all have been computed.
                    setUpHorizontalScroll($(this));

                    // Now we're ready, call setScene on load that adds classes based on scroll position.
                    setScene($(this));

                    // Resize function
                    $(window).on('resize', function () {
                        // Reset horizontal scrolling data attributes and transform content wrapper if transform is bigger than scroll width.
                        resetHorizontalScroll($thisSection);
                        // Reset scene positioning.
                        setScene($thisSection);
                    });

                });

                function setupHorizontalTriggers($el, section) {
                    var parent = $el.parent();
                    var positionLeft = parent.position().left;
                    var positionLeftMinus = -(positionLeft);
                    var triggerOffset = $el.data('triggerOffset');
                    triggerOffset = !triggerOffset ? 0.5 : triggerOffset = triggerOffset;
                    $el.data('triggerOffset', triggerOffset);
                    $el.data('triggerPositionLeft', positionLeftMinus);
                    $el.data('triggerSection', section);
                }

                function useHorizontalTriggers($el) {
                    if ($el.data('triggerSection').data('transformX') <= ($el.data('triggerPositionLeft') * $el.data('triggerOffset'))) {
                        $el.data('triggerSection').addClass($el.data('class'));
                    } else {
                        if ($el.data('remove-class') !== false) {
                            $el.data('triggerSection').removeClass($el.data('class'));
                        }
                    }
                }

                $horizontalScrollSectionsTriggers.each(function (i, el) {
                    setupHorizontalTriggers($(this), $(this).closest('.horizontal-scroll-section'));
                });

                function transformBasedOnScrollHorizontalScroll($el) {

                    // Get amount scrolled variables.
                    var amountScrolledContainer = winScrollTop - $el.data('offsetTop');
                    var amountScrolledThrough = (amountScrolledContainer / ($el.data('outerHeight') - (winHeight - winWidth)));

                }

                // 
                $(window).on('scroll', function(){
                 
                    // Get window scroll top.
                    winScrollTop = $(window).scrollTop();

                    // Each function in horizontal scroll sections.
                    $horizontalScrollSections.each(function (i, el) {
                        transformBasedOnScrollHorizontalScroll($(this));
                        setScene($(this));
                    });

                    // Each function for horizontal scroll section triggers.
                    $horizontalScrollSectionsTriggers.each(function (i, el) {
                        useHorizontalTriggers($(this));
                    });
                             
                });

            });

    });

    
});
jQuery(document).ready(function() {
  megamenu_image();
  $(".site-nav>.site-nav__item").hover(function(){
    setTimeout(function() {  
      megamenu_image();
    }, 10);
  }, function(){
    setTimeout(function() {  
      megamenu_image();
    }, 10);
  });
  $(window).resize(function(){
      megamenu_image();
      $(".site-nav>.site-nav__item").hover(function(){
        setTimeout(function() {  
          megamenu_image();
        }, 10);
      }, function(){
        setTimeout(function() {  
          megamenu_image();
        }, 10);
      });
  });
});
function megamenu_image(){
    var img_width = jQuery('.site-nav .grid__item.three-quarters.not-image>ul .nav-collection_image').width();
    jQuery('.site-nav .grid__item.three-quarters.not-image>ul .nav-collection_image img').css('height', img_width);
}